import {useQuery} from '@tanstack/react-query';
import {useDispatch} from 'react-redux';
import {
    OrganizationWithCatalogsAttributesAndPriceTiers,
    searchForOrganization,
} from '../../../lib/entity';
import {recieveOrganizationInformation} from '../../../redux/actions/OrganizationActions';

export const useSearchForOrganizationQuery = (organizationId) => {
    const dispatch = useDispatch();
    return useQuery({
        enabled: !!organizationId,
        queryKey: ['search-for-organization', organizationId],
        queryFn: (context) => searchForOrganization(organizationId, dispatch),
        onSuccess: (data) => {
            dispatch(
                recieveOrganizationInformation(
                    data as OrganizationWithCatalogsAttributesAndPriceTiers
                )
            );
        },
    });
};
